export default __webpack_public_path__ + "static/media/017-microprocessor.512a9dfa.svg";